import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

import { AttentionIcon, Button } from '@blade/ui-kit'
import { useWebSignIn } from '@root/features/auth/web-sign-in'
import { InfoMessage } from '@root/shared/ui-kit'

export const DataTableMessageLogin: React.FC = () => {
  const { t } = useTranslation()

  const signIn = useWebSignIn()

  return (
    <InfoMessage
      intent="empty"
      title={t('table.message.no_data')}
      description={t('table.message.login_to_account')}
      variant="dt"
      withBackground
      withSeparator
      icon={<AttentionIcon />}
      css={css`
        height: 100%;
      `}
    >
      <ButtonLogin
        onClick={() => signIn()}
        size="xs"
        color="primary"
        radius="rounded"
      >
        {t('access.door.telegram')}
      </ButtonLogin>
    </InfoMessage>
  )
}

const ButtonLogin = styled(Button)`
  height: 28px;
  font-weight: 500;
`
